module.exports = "<svg width=\"16\" height=\"8\" viewBox=\"0 0 16 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 3H0v2h10v3l5.549-3.7c.251-.167.25-.435 0-.6L10 0v3z\" fill-rule=\"nonzero\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/ee/app/views/shared/icons/_arrow_mini_pipeline_graph.svg
// module id = ../../../ee/app/views/shared/icons/_arrow_mini_pipeline_graph.svg
// module chunks = pages.projects.merge_requests.show